export default "__VITE_ASSET__43sd__JS__"